/** Host suffix for built-in Management API resource indicators (`https://{tenantId}.{suffix}/api`). */
export const managementApiHostSuffix = 'kumpe.app';
export const managementApiProductName = 'KumpeCloud Management API';
export const managementApiAccessRoleName = 'KumpeCloud Management API access';
export const managementApiAccessRoleDescription = 'This default role grants access to the KumpeCloud Auth management API.';
export const meApiProductName = 'KumpeCloud Me API';
